import { useContext } from "react";
import SubscriptionFormContext from "./SubscriptionFormContext";
import {
  CheckBadgeIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";

export default function BenefitsList() {
  const { benefits } = useContext(SubscriptionFormContext);

  return (
    <ul
      className="
        xfont-grotesque xfont-semibold xtext-4xl xtext-extra-dark-green
        xflex xflex-col xgap-2 md:xgap-4
        xml-6
      "
    >
      {benefits.map(
        ({ label, extraInfo, modalHeader, linkText, linkUrl }, index) => (
          <li key={index} className="xflex xitems-start xgap-2">
            <CheckBadgeIcon className="xsize-10 md:xsize-12 xtext-orange xmt-1 xflex-shrink-0" />
            <div className="xflex xitems-center xgap-2">
              <span className="xfont-grotesque xfont-semibold xtext-3xl xl:xtext-4xl xtext-extra-dark-green">
                {label}
              </span>
              {extraInfo && (
                <>
                  <QuestionMarkCircleIcon
                    className="
                    xinline
                     xtext-dark-green
                     xcursor-pointer
                      xsize-10
                    "
                    onClick={() => {
                      const modal = document.getElementById(
                        `benefitModal_${index}`
                      ) as HTMLDialogElement;
                      modal?.showModal();
                    }}
                  />

                  {/* Modal */}
                  <dialog id={`benefitModal_${index}`} className="xmodal">
                    <div className="xmodal-box xp-8 xbg-light-creme">
                      <h2
                        className="
                        xfont-grotesque xfont-black
                        xtext-4xl xmb-4 xtext-extra-dark-green
                      "
                      >
                        {modalHeader || label}
                      </h2>
                      <div
                        className="
                        xpy-4 xfont-grotesque
                        xfont-semibold xtext-extra-dark-green
                        xtext-3xl xtext-justify
                      "
                      >
                        {extraInfo}
                        {linkText && linkUrl && (
                          <a
                            href={linkUrl}
                            className="xtext-orange hover:xtext-orange-600 xunderline"
                          >
                            {linkText}
                          </a>
                        )}
                      </div>
                      <div className="xmodal-action">
                        <form method="dialog">
                          <button className="xbtn xbtn-primary xtext-xl">
                            Close
                          </button>
                        </form>
                      </div>
                    </div>
                    <form method="dialog" className="xmodal-backdrop">
                      <button>close</button>
                    </form>
                  </dialog>
                </>
              )}
            </div>
          </li>
        )
      )}
    </ul>
  );
}
